import React, { useState, useEffect, useContext } from 'react';
import { Button, FormGroup, Label, Input } from 'reactstrap';
import { AppContext } from '../AppContext';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Card, CardHeader, CardBody, Row, Col } from 'reactstrap';
import { FaFileExcel } from 'react-icons/fa';
import withRoleAccess from './withRoleAccess';

const MySwal = withReactContent(Swal);
const APIURL = process.env.REACT_APP_API_URL;

const ReportesTecnologias = () => {

    const [yearTecnologia, setYearTecnologia] = useState('');
    const [termTecnologia, setTermTecnologia] = useState('');
    const [cicloTecnologia, setCicloTecnologia] = useState('');
    const [yearsTecnologia, setYearsTecnologia] = useState([]);
    const [ciclosTecnologia, setCiclosTecnologia] = useState([]);

    const currentUser = useContext(AppContext).currentUser;

    useEffect(() => {
        if (!currentUser) return;

        const fetchYears = async () => {
            try {
                MySwal.fire({
                    title: 'Cargando...',
                    text: 'Espere un momento',
                    allowOutsideClick: false,
                    didOpen: () => {
                        MySwal.showLoading();
                    }
                });

                const response = await fetch(`${APIURL}/api/reporte-usuario/periodo-encuesta-tecnologias`);
                const data = await response.json();

                setYearsTecnologia(data);
                if (data.length > 0) {
                    setYearTecnologia(data[0].anioAcademico);
                }

                MySwal.close();
            } catch (error) {
                console.error('Error al consultar los datos:', error);
                MySwal.close();
            }
        };

        fetchYears();
    }, [currentUser]);

    useEffect(() => {
        if (!yearTecnologia || !termTecnologia) return;

        const fetchCiclos = async () => {
            try {
                MySwal.fire({
                    title: 'Cargando ciclos...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        MySwal.showLoading();
                    }
                });

                const response = await fetch(`${APIURL}/api/reporte-usuario/get-ciclos-tecnologias?anio=${yearTecnologia}&termino=${termTecnologia}`);
                const data = await response.json();

                setCiclosTecnologia(data);
                MySwal.close();
            } catch (error) {
                console.error('Error al consultar los ciclos:', error);
                MySwal.close();
            }
        };

        fetchCiclos();
    }, [yearTecnologia, termTecnologia]);


    const handleYearTecnologiaChange = (e) => {
        setYearTecnologia(e.target.value);
    };

    const handleTermTecnologiaChange = (e) => {
        setTermTecnologia(e.target.value);
        setCicloTecnologia('');
    };

    const handleCicloTecnologiaChange = (e) => {
        setCicloTecnologia(e.target.value);
    };


    const downloadReportTecnologia = async (endpoint, tipoEncuesta) => {
        if (!yearTecnologia || !termTecnologia || !cicloTecnologia) {
            MySwal.fire('Error', 'Debe seleccionar Año, Término y Ciclo antes de generar el reporte.', 'error');
            return;
        }

        try {
            MySwal.fire({
                title: 'Generando reporte...',
                allowOutsideClick: false,
                didOpen: () => {
                    MySwal.showLoading();
                }
            });

            const requestBody = {
                Anio: yearTecnologia,
                Termino: termTecnologia,
                Ciclo: cicloTecnologia,
                Encuesta: tipoEncuesta
            };

            const response = await fetch(`${APIURL}${endpoint}`, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            });

            if (!response.ok) {
                throw new Error(`Error en la solicitud: ${response.status} - ${response.statusText}`);
            }

            const contentDisposition = response.headers.get('Content-Disposition');
            let filename = 'reporte.xlsx';
            if (contentDisposition) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(contentDisposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }

            const blob = await response.blob();
            MySwal.close();
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
        } catch (error) {
            MySwal.fire('Error', 'No se pudo generar el reporte.', 'error');
        }
    };

    return (
        <>
            <h1 id="pageHeader">Reportes consolidados</h1>
            <div style={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
                {currentUser && currentUser.usuario && currentUser.roles
                    && (currentUser.roles.some(r => r.role === "ADMIN")) &&
                    <Card>
                        <CardHeader>TECNOLOGÍAS</CardHeader>
                        <CardBody>
                            <Row form>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label for="yearSelectTecnologia">Año</Label>
                                        <Input type="select" name="yearTecnologia" id="yearSelectTecnologia" onChange={handleYearTecnologiaChange}>
                                            {yearsTecnologia.map((y, index) => (
                                                <option key={index} value={y.anioAcademico}>{y.anioAcademico}</option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label for="termSelectTecnologia">Término</Label>
                                        <Input type="select" name="termTecnologia" id="termSelectTecnologia" onChange={handleTermTecnologiaChange}>
                                            <option value="">Seleccionar un término</option>
                                            <option value="1S">1S</option>
                                            <option value="2S">2S</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label for="cicloSelectTecnologia">Ciclo</Label>
                                        <Input type="select" name="cicloTecnologia" id="cicloSelectTecnologia" onChange={handleCicloTecnologiaChange} disabled={!ciclosTecnologia.length}>
                                            <option value="">Seleccionar un ciclo</option>
                                            {ciclosTecnologia.map((ciclo, index) => (
                                                <option key={index} value={ciclo.value}>{ciclo.label}</option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div style={{ display: "flex", gap: "1rem" }}>
                                        <Button
                                            color="primary"
                                            onClick={() => downloadReportTecnologia('/api/reporte-usuario/reporte-tecnologias', 'tutores')}
                                            disabled={!yearTecnologia || !termTecnologia || !cicloTecnologia}
                                        >
                                            <FaFileExcel /> Tutores
                                        </Button>
                                        <Button
                                            color="primary"
                                            onClick={() => downloadReportTecnologia('/api/reporte-usuario/reporte-tecnologias', 'servicios')}
                                            disabled={!yearTecnologia || !termTecnologia || !cicloTecnologia}
                                        >
                                            <FaFileExcel /> Servicios
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                }
            </div>
        </>
    );
};

export default withRoleAccess(ReportesTecnologias, ["ADMIN"]); // "COORDINADOR_TECN", ver todos los lados donde incluya ADMIN